import { apiPath } from "./GeneralFunc";

const FetchAllActiveCountEvents = async (userToken: string) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", token: userToken },
  };
  const response = await fetch(
    apiPath + "/getAllActiveCountEvents",
    requestOptions
  );
  if (!response.ok) {
  }
  const result = await response.text();
  return result;
};

export default FetchAllActiveCountEvents;
